import { RoomV2Entity } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import { RoomsListCmd } from "@youm-front/room/domain";

export const roomsPastList = createAction(
  "[Room] Rooms Past List",
  props<{
    roomsListCmd: RoomsListCmd;
  }>()
);
export const roomsPastListSuccess = createAction(
  "[Room] Rooms Past List Success",
  props<{ rooms: RoomV2Entity[] }>()
);
export const roomsPastListFailure = createAction(
  "[Room] Rooms Past List Failure",
  props<{ message: string }>()
);
